import React, { useEffect, useState } from 'react';

const CustomeIcon = (props) => {
    let src, alt, classes, id = null;
    // useEffect(() => {
        props.src == undefined ? src = './images/spacer.png' : src = props.src;
        props.alt == undefined ? alt = 'Sharp Kitchen' : alt = props.alt;
        props.classList == undefined ? classes = '' : classes = props.classList;
        props.id == undefined ?  id = 'sharp-'+ parseInt(Math.random()*1000) : id = props.id;
        
      
        // console.log(src);
        // console.log(alt);
        // console.log(classes);
        // console.log(id);
    //   });

    return(
        <>
        <img src={src} alt={alt} className={classes} id={id} />
        </>
    )
} 

export default CustomeIcon;